import styles from './NavigationDesktop.module.scss'
import { getNavigationItems } from 'components/page-header/utils'
import Link from 'next/link'
import { Button, Dropdown, DropdownItem } from '@boltenergy-be/design-system'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { Language } from 'types/language'

const NavigationDesktop = () => {
  // i18n
  const { t } = useTranslation('header')

  // Router
  const router = useRouter()
  const { locale } = router

  return (
    <nav className={styles.navigation}>
      <ul>
        {getNavigationItems(locale as Language).map(({ key, route, children }) => (
          <li key={key}>
            {route ? (
              <Link href={route} className={styles.item}>
                {t(`navigation.${key}`)}
              </Link>
            ) : (
              <Dropdown
                customTrigger={
                  <Button variant="tertiary" trailingIcon="chevronDown" className={styles.item}>
                    {t(`navigation.${key}.root`)}
                  </Button>
                }
              >
                {children?.map(({ key, route }) =>
                  route ? <DropdownItem key={key} onClick={() => router.push(route)} label={t(`navigation.${key}`)} /> : null
                )}
              </Dropdown>
            )}
          </li>
        ))}
      </ul>
    </nav>
  )
}

export default NavigationDesktop
